"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitButton = exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

require("./Button.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var concatAll = (0, _ramda.unapply)((0, _ramda.reduce)(_ramda.concat, []));

var mkButton = function mkButton(buttonType) {
  return function (_ref) {
    var children = _ref.children,
        className = _ref.className,
        type = _ref.type,
        small = _ref.small,
        large = _ref.large,
        restProps = _objectWithoutProperties(_ref, ["children", "className", "type", "small", "large"]);

    var classes = concatAll(['vs-btn-d', "vs-".concat(type, "-btn")], small ? ['vs-sm-btn'] : [], large ? ['vs-lg-btn'] : [], className ? [className] : []);
    return _react.default.createElement("button", _extends({}, restProps, {
      type: buttonType,
      className: classes.join(' ')
    }), children);
  };
};

var Button = mkButton('button');
exports.Button = Button;
var SubmitButton = mkButton('submit');
exports.SubmitButton = SubmitButton;
Button.propTypes = SubmitButton.propTypes = {
  type: _propTypes.default.oneOf(['primary', 'success', 'info', 'default', 'warning', 'danger', 'solid-primary', 'solid-primary-raised', 'solid-secondary', 'outline-primary', 'outline-secondary', 'outline-secondary-raised', 'rounded-solid', 'rounded-outline', 'icon', 'text', 'text-link', 'inline-outline-secondary', 'solid-primary-pill', 'solid-secondary-pill', 'solid-outline-raised-pill']).isRequired,
  small: _propTypes.default.bool,
  large: _propTypes.default.bool
};